import React from "react";

export function Login({
  shown,
  handle = ()=>void(0),
  hanleClose = ()=>void(0)
}) {
  return (
    <div
      id="mainctapop"
      data-a="target"
      className={`log0 ${shown ? 'shown' : ''}`}
      style={{position: 'absolute'}}
    >
      <div
        data-a="close"
        className={`p_fcard_z ${shown ? 'shown' : ''}`}
        onClick={hanleClose}
      />
      <div className={`p_fcard ${shown ? 'shown' : ''}`}>
        <div className="p_content-block p_content-block--lp">
          <div className="p_fcard_c0">
            <div className="p_fcard_c">
              <div className="p_fcard_c_grid">
                <div className="p_fcard_c_grid--2">
                  <div className="p_log0">
                    <div className="login_body">
                      <div className="x_int_login_h1">
                        Start by creating <br />
                        an account
                      </div>
                      <div className="l_paddings_s">
                        <div className="x_log_steps0">
                          <div
                            data-step1="trigger"
                            className="x_log_step shown"
                          >
                            <div>1</div>
                          </div>
                          <div className="x_log_step_line" />
                          <div data-step1="trigger" className="x_log_step">
                            <div>2</div>
                          </div>
                        </div>
                      </div>
                      <div data-step1="target" className="x_log_step1 shown">
                        <div className="w-form">
                          <form
                            id="email-form"
                            name="email-form"
                            data-name="Email Form"
                            className="x_log_form0"
                          >
                            <div>
                              <div className="l_line">
                                <label htmlFor="name">Name*</label>
                                <input
                                  type="text"
                                  className="x_log_input w-input"
                                  maxLength={256}
                                  name="name-4"
                                  data-name="Name 4"
                                  placeholder="John Maeda"
                                  id="name-4"
                                />
                              </div>
                              <div className="l_line">
                                <label htmlFor="email">
                                  Company or individual name*
                                </label>
                                <input
                                  type="text"
                                  className="x_log_input w-input"
                                  maxLength={256}
                                  name="email-4"
                                  data-name="Email 4"
                                  placeholder="Company Name LLC"
                                  id="email-4"
                                  required
                                />
                              </div>
                              <div className="l_line">
                                <label htmlFor="email">
                                  Number of employees
                                </label>
                                <div className="x_log_rad0">
                                  <div className="x_log_rad_li">
                                    <div>1–20</div>
                                  </div>
                                  <div className="x_log_rad_li">
                                    <div>20–300</div>
                                  </div>
                                  <div className="x_log_rad_li">
                                    <div>301–1000</div>
                                  </div>
                                  <div className="x_log_rad_li">
                                    <div>1000+</div>
                                  </div>
                                </div>
                              </div>
                              <div className="l_line">
                                <label htmlFor="email">
                                  Company/game website
                                </label>
                                <input
                                  type="email"
                                  className="x_log_input w-input"
                                  maxLength={256}
                                  name="email-4"
                                  data-name="Email 4"
                                  placeholder="yourname@yourworkemail.com"
                                  id="email-4"
                                  required
                                />
                              </div>
                              <div className="l_line">
                                <label htmlFor="role">
                                  <strong>
                                    What best describes your role?
                                  </strong>
                                </label>
                                <select
                                  id="role-2"
                                  name="role-2"
                                  data-name="Role 2"
                                  className="x_log_input x_solutions_form_input--select w-select"
                                >
                                  <option value>Select one...</option>
                                  <option value="ceo">
                                    CEO/Executive/Founder
                                  </option>
                                  <option value="Second">Second Choice</option>
                                  <option value="Third">Third Choice</option>
                                </select>
                              </div>
                            </div>
                            <div>
                              <div className="l_line">
                                <div
                                  onClick={handle}
                                  data-step1="trigger"
                                  className="x_log_next"
                                >
                                  Next
                                </div>
                              </div>
                            </div>
                          </form>
                          <div className="w-form-done">
                            <div>
                              Thank you! Your submission has been received!
                            </div>
                          </div>
                          <div className="w-form-fail">
                            <div>
                              Oops! Something went wrong while submitting the
                              form.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div data-step1="target" className="x_log_step1">
                        <div data-step1="target" className="w-form">
                          <form
                            id="email-form"
                            name="email-form"
                            data-name="Email Form"
                            className="x_log_form0"
                          >
                            <div>
                              <div className="l_line">
                                <label htmlFor="name">Email*</label>
                                <input
                                  type="text"
                                  className="x_log_input w-input"
                                  maxLength={256}
                                  name="name-4"
                                  data-name="Name 4"
                                  placeholder="mikoza@gmail.com"
                                  id="name-4"
                                />
                              </div>
                              <div className="l_line">
                                <label htmlFor="password">
                                  Create password*
                                </label>
                                <input
                                  type="text"
                                  className="x_log_input w-input"
                                  maxLength={256}
                                  name="password"
                                  data-name="Password"
                                  placeholder="******"
                                  id="password"
                                  required
                                />
                              </div>
                              <div className="l_line">
                                <div>
                                  I hereby give{" "}
                                  <a href="https://xsolla.com/consent?xsolla_lang=en">
                                    consent
                                  </a>{" "}
                                  to the processing of my personal data and
                                  agree to be bound by{" "}
                                  <a href="https://xsolla.com/privacy-policy?xsolla_lang=en">
                                    the Privacy Policy
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="l_line">
                              <div className="l_flex-2 l_flex--stretch">
                                <div
                                  data-step1="trigger"
                                  className="x_log_next x_log_next--ghost"
                                >
                                  <div>Back</div>
                                </div>
                                <div
                                  data-step1="trigger"
                                  className="x_log_next"
                                >
                                  <div>Get started</div>
                                </div>
                              </div>
                            </div>
                          </form>
                          <div className="w-form-done">
                            <div>
                              Thank you! Your submission has been received!
                            </div>
                          </div>
                          <div className="w-form-fail">
                            <div>
                              Oops! Something went wrong while submitting the
                              form.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="x_int_login_cardbg" />
                  </div>
                </div>
              </div>
              <div data-a="close" className="p_fcard_hide0">
                <div className="p_fcard_hide_x w-embed">
                  <svg
                    width={18}
                    height={18}
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M9.00036 10.4146L2.6163 16.7986C2.30388 17.1111 1.79735 17.1111 1.48493 16.7986L1.20209 16.5158C0.889669 16.2034 0.889669 15.6968 1.20209 15.3844L7.58615 9.00036L1.20209 2.6163C0.889668 2.30388 0.889669 1.79735 1.20209 1.48493L1.48493 1.20209C1.79735 0.889669 2.30388 0.889669 2.6163 1.20209L9.00036 7.58615L15.3844 1.20209C15.6968 0.889668 16.2034 0.889669 16.5158 1.20209L16.7986 1.48493C17.1111 1.79735 17.1111 2.30388 16.7986 2.6163L10.4146 9.00036L16.7986 15.3844C17.1111 15.6968 17.1111 16.2034 16.7986 16.5158L16.5158 16.7986C16.2034 17.1111 15.6968 17.1111 15.3844 16.7986L9.00036 10.4146Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
